import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070ac436"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Technician"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Equipment"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Type of Job"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Service Report Log"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_FilterComponent = _resolveComponent("FilterComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_button, {
      strong: "",
      secondary: "",
      circle: "",
      type: "primary",
      size: "large",
      class: "fab",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(`maintenance/create`)))
    }, {
      icon: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_FilterComponent, { onFilter: _ctx.getFilter }, null, 8, ["onFilter"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              class: "table align-items-center table-flush ellipsis",
              options: _ctx.options,
              onInstance: _ctx.dtInstance,
              id: "maintenance-list"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["options", "onInstance"])
          ])
        ])
      ])
    ])
  ]))
}